import Env from "../environments";
import { ROOT_GLOBAL } from "../global/root";
import { getCountry } from "../utils/country";
import { LocalStorage } from "./LocalStorage";
import { Paging } from "./Paging";
import { SearchFacet } from "./SearchFacet";
import { SearchProduct } from "./SearchProduct";

export class Search {
  constructor(
    products,
    paging,
    facets,
    filters,
    metaTitle,
    metaDescription,
  ) {
    /** @type {[SearchProduct]}*/
    this.products = products;
    /** @type {Paging}*/
    this.paging = paging;
    /** @type {[SearchFacet]}*/
    this.facets = facets;
    this.filters = filters;
    this.metaTitle = metaTitle;
    this.metaDescription = metaDescription;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Search(
        SearchProduct.fromApiArray(input.data),
        Paging.fromApiObject(input.paging),
        SearchFacet.fromApiArray(input.facets),
        input.filters,
        input.meta_title,
        input.meta_description,
      )
    }

    return new Search();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Search.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Search.fromApiObject(input)];
    }

    return [];
  }

  static getRedirectSearch(key, isRedirect = false, source) {
    let href = ROOT_GLOBAL.SEARCH + "?" + this.TERM + "=" + encodeURIComponent(key);
    if (source) href += "&dc_source=" + source;
    if (isRedirect) {
      window.location.href = href;
    } else {
      return href;
    }
  }

  /**
   * 
   * @param {*} dt 
   * @param {*} perPage 
   * @returns {{ p, pp, fl, t, f, bst, soas }}
   */
  static genDefaultParams(dt, perPage) {
    return {
      "p": 1,
      "pp": perPage,
      "fl": 0,
      "i": Env.DUTY_CAST_EXTENSION_SEARCH_INDEX,
      "dt": [dt],
      "t": {},
      "f": {},
    }
  }

  static genLangParams() {
    let langague = [];

    let lang = LocalStorage.getLanguage() || "en";
    if (lang === "vi") {
      langague.push(lang);
    } else {
      let country = getCountry(LocalStorage.getIpCountry());
      if (country?.lang && !langague.includes(country.lang)) {
        langague.push(country.lang);
      }
    }
    if (!langague.includes("en")) {
      langague.push("en");
    }

    return langague;
  }

  static genTermParams(termSearch = "") {
    let params = {};

    if (termSearch) {
      let lang = LocalStorage.getLanguage() || "en";
      if (lang === "vi") {
        params[lang] = [termSearch];
      } else {
        let country = getCountry(LocalStorage.getIpCountry());
        if (country?.lang && !params[country.lang]) {
          params[country.lang] = [termSearch];
        }

        let shipCountry = getCountry(LocalStorage.getShipping());
        if (shipCountry?.lang && !params[shipCountry.lang]) {
          params[shipCountry.lang] = [termSearch];
        }
      }
      if (!params["en"]) {
        params["en"] = [termSearch];
      }
    }

    return params;
  }

  static TERM = "k"
  static FILTER = "filter"
  static SOURCE = {
    AUTOCOMPLETE: "autocomplete",
    SEARCH_INPUT: "search_input",
    SEARCH_FILTER: "search_filter",
    SEARCH_RESULT: "search_result",
    RECOMMEND: "recommend",
    HOME_FEATURED: "home_featured",
    AVAILABLE_STORE: "available_store",
  }
  static TYPE = {
    FACET: "facet",
    SEARCH: "search",
    TRANSLATE: "translate"
  }

  static SEARCH_TYPE = {
    PRODUCT: "product",
    SITE: "site",
    CATEGORY: "category",
  }
}